if (!customElements.get('product-promo-offer')) {
  class ProductPromoOffer extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
      this.offers = this.querySelectorAll('[data-promo-offer]');
      this.productFormArr = this.closest('product-info').querySelectorAll('product-form');
      this.productForm = this.closest('product-info').querySelector('product-form');
      this.productSub = this.querySelector('[data-promo-subscription]');
      if (!this.productSub) {
        this.productSub = document.querySelector('[data-promo-subscription]');
      }
      if (window.productPromoOfferAb) {
        if (window.productPromoOfferAbIg) {
          this.initBeforeStart();
        }
      } else {
        this.initBeforeStart();
      }
    }

    initBeforeStart() {

      // selected quantity
      this.quantity = parseInt(document.querySelector('[data-promo-offer].active').dataset.offerQ);
      this.productId = this.dataset.subPromoId;
      this.combination = this.productId + ':' + this.quantity;
      this.subs2 = false;
      if (this.dataset.subsTwo) {
        this.subs2 = true;
      }

      // update selected quantity
      this.productForm.querySelector('input[name="quantity"]').value = this.quantity;

      // update selected selling plan and discount
      if (this.productSub.classList.contains('active')) {
        this.productForm.querySelector('#selling_plan').value = document.querySelector('[data-promo-offer].active').dataset.offerSubie;
        this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": document.querySelector('[data-promo-offer].active').dataset.offerDiscountSub,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});
      } else {
        this.productForm.querySelector('#selling_plan').value = '';
        this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": document.querySelector('[data-promo-offer].active').dataset.offerDiscount,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});;
      }

      // update subscription notice
      let currentQ = 0;
      if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '1') {
        document.querySelector('[data-sub-offer="1"]').classList.remove('hidden');
        document.querySelector('[data-sub-offer="2"]').classList.add('hidden');
        document.querySelector('[data-sub-offer="3"]').classList.add('hidden');
        if (!document.querySelector('.ccf-bms__toggle')) {
          if (document.querySelector('[data-subs-two-offer]')) {
            document.querySelector('[data-subs-two-offer]').classList.add('hidden');
          }
        }
        currentQ = 1;
      }

      if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '2') {
        document.querySelector('[data-sub-offer="1"]').classList.add('hidden');
        document.querySelector('[data-sub-offer="2"]').classList.remove('hidden');
        document.querySelector('[data-sub-offer="3"]').classList.add('hidden');
        if (!document.querySelector('.ccf-bms__toggle')) {
          if (document.querySelector('[data-subs-two-offer]')) {
            document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
          }
        }
        currentQ = 2;
      }

      if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '3') {
        document.querySelector('[data-sub-offer="1"]').classList.add('hidden');
        document.querySelector('[data-sub-offer="2"]').classList.add('hidden');
        document.querySelector('[data-sub-offer="3"]').classList.remove('hidden');
        if (!document.querySelector('.ccf-bms__toggle')) {
          if (document.querySelector('[data-subs-two-offer]')) {
            document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
          }
        }
        currentQ = 3;
      }

      // add required properties for tags
      if (!this.productForm.querySelector('[name="properties[_new_tagging]"]')) {

        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_subscription_offer]';
        input.value = this.dataset.flowTag;
        this.productForm.querySelector('form').appendChild(input);

        let input2 = document.createElement('input');
        input2.type = 'hidden';
        input2.name = 'properties[_subscription_type]';
        if (this.productSub.classList.contains('active')) {
          input2.value = 'subscription';
        } else {
          input2.value = 'reg_purchase';
        }
        input2.id = 'sub_type';
        this.productForm.querySelector('form').appendChild(input2);

        let input3 = document.createElement('input');
        input3.type = 'hidden';
        input3.name = 'properties[_subscription_variant]';
        input3.value = currentQ;
        input3.id = 'sub_q';
        this.productForm.querySelector('form').appendChild(input3);
      }

      this.initStart();
    }

    initStart() {
      let that = this;
      this.offers.forEach((offer) => {
        offer.addEventListener('click', (e) => {
          let target = e.target;
          if (e.target.dataset) {
            if (e.target.dataset.promoOffer) {
              target = e.target;
            } else {
              target = e.target.closest('[data-promo-offer]');
            }
          } else {
            target = e.target.closest('[data-promo-offer]');
          }
          that.querySelector('[data-promo-offer].active').classList.remove('active');
          target.classList.add('active');

          // update quantity
          this.quantity = target.dataset.offerQ;
          this.productForm.querySelector('input[name="quantity"]').value = this.quantity;

          // update selling plan
          if (this.productSub.classList.contains('active')) {
            let offerSubie = target.dataset.offerSubie;
            this.productForm.querySelector('#selling_plan').value = offerSubie;
          } else {
            this.productForm.querySelector('#selling_plan').value = '';
          }

          this.combination = this.productId + ':' + this.quantity;

          // update discount
          if (this.productSub.classList.contains('active')) {
            this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": target.dataset.offerDiscountSub,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});
          } else {
            this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": target.dataset.offerDiscount,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});
          }

          // update subscription notice
          if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '1') {
            document.querySelector('[data-sub-offer="1"]').classList.remove('hidden');
            document.querySelector('[data-sub-offerz="1"]').classList.remove('hidden');
            document.querySelector('[data-sub-offer="2"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="2"]').classList.add('hidden');
            document.querySelector('[data-sub-offer="3"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="3"]').classList.add('hidden');
            if (!document.querySelector('.ccf-bms__toggle')) {
              if (document.querySelector('[data-subs-two-offer]')) {
                document.querySelector('[data-subs-two-offer]').classList.add('hidden');
              }
            }
          }

          if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '2') {
            document.querySelector('[data-sub-offer="1"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="1"]').classList.add('hidden');
            document.querySelector('[data-sub-offer="2"]').classList.remove('hidden');
            document.querySelector('[data-sub-offerz="2"]').classList.remove('hidden');
            document.querySelector('[data-sub-offer="3"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="3"]').classList.add('hidden');
            if (!document.querySelector('.ccf-bms__toggle')) {
              if (document.querySelector('[data-subs-two-offer]')) {
                document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
              }
            }
          }

          if (document.querySelector('[data-promo-offer].active').dataset.offerQ == '3') {
            document.querySelector('[data-sub-offer="1"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="1"]').classList.add('hidden');
            document.querySelector('[data-sub-offer="2"]').classList.add('hidden');
            document.querySelector('[data-sub-offerz="2"]').classList.add('hidden');
            document.querySelector('[data-sub-offer="3"]').classList.remove('hidden');
            document.querySelector('[data-sub-offerz="3"]').classList.remove('hidden');
            if (!document.querySelector('.ccf-bms__toggle')) {
              if (document.querySelector('[data-subs-two-offer]')) {
                document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
              }
            }
          }

          // update properties for tags
          this.productForm.querySelector('#sub_q').value = document.querySelector('[data-promo-offer].active').dataset.offerQ;
        });
      });

      this.productSub.addEventListener('click', (e) => {

        let target = e.target;
        let closestSelection = '';

        if (target.closest('product-promo-offer') === null) {
          closestSelection = target.closest('product-info').querySelector('[data-promo-offer].active');
        } else {
          closestSelection = target.closest('product-promo-offer').querySelector('[data-promo-offer].active');
        }

        this.quantity = parseInt(document.querySelector('[data-promo-offer].active').dataset.offerQ);
        this.combination = this.productId + ':' + this.quantity;

        if (!target.classList.contains('offer-selector')) {
          target = e.target.closest('[data-promo-subscription]');
        }
        if (target.classList.contains('active')) {
          target.classList.remove('active');
          that.classList.remove('subs');
          this.productForm.querySelector('#selling_plan').value = '';

          // update selling plan
          this.productForm.querySelector('#selling_plan').value = '';
          this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": closestSelection.dataset.offerDiscount,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});

          // update properties
          this.productForm.querySelector('#sub_type').value = 'reg_purchase';

        } else {
          target.classList.add('active');
          that.classList.add('subs');
          let thePlan = that.querySelector('[data-promo-offer].active').dataset.offerSubie;
          this.productForm.querySelector('#selling_plan').value = thePlan;
          this.productForm.querySelector('[data-prime-discounts-property]').value = JSON.stringify({"discount": "true","amount": closestSelection.dataset.offerDiscountSub,"type": "percent","label": "Bundle offer","combination": this.combination, "allow_subs": true, "cart_totals": 0});
          // update properties
          this.productForm.querySelector('#sub_type').value = 'subscription';
        }
      })


      if (document.querySelector('.ccf-bms__toggle')) {
        if (document.querySelector('.ccf-bms__tog--active').dataset.mode == 'sub') {
          if (document.querySelector('[data-subs-two-offer]')) {
            document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
          }
        }
      }

      document.querySelectorAll('.ccf-bms__tog').forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          let target = e.target;
          if (typeof target.dataset !== 'undefined') {
            target = e.target.closest('.ccf-bms__tog');
          }
          if (document.querySelector('[data-promo-subscription]')) {
            if (!target.classList.contains('ccf-bms__tog--active')) {
              let mode = target.dataset.mode;
              if (mode == 'sub') {
                document.querySelector('[data-mode="once"]').classList.remove('ccf-bms__tog--active');
                document.querySelector('[data-mode="sub"]').classList.add('ccf-bms__tog--active');
                if (document.querySelector('[data-subs-two-offer]')) {
                  document.querySelector('[data-subs-two-offer]').classList.remove('hidden');
                }
              } else {
                document.querySelector('[data-mode="sub"]').classList.remove('ccf-bms__tog--active');
                document.querySelector('[data-mode="once"]').classList.add('ccf-bms__tog--active');
                if (document.querySelector('[data-subs-two-offer]')) {
                  document.querySelector('[data-subs-two-offer]').classList.add('hidden');
                }
              }
              document.querySelector('[data-promo-subscription]').click();
            }
          }
        })
      })
    }

  }

  window.ProductPromoOffer = ProductPromoOffer;
  customElements.define('product-promo-offer', ProductPromoOffer);
}
